import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { formatPrice } from '../../../../utils';
import { handleNumericKeyDown, customSelectStyles } from '../OrderFormUtils';

const AksesuarForm = ({
  newOrder,
  onFieldChange,
  isLoading,
  productItems,
  productOptions,
  handleProductSelect
}) => {
  return (
    <>
      <div className="form-group">
        <label>Oda Adı *</label>
        <input type="text" value={newOrder.roomName || ''} onChange={(e) => onFieldChange('roomName', e.target.value)} required disabled={isLoading} placeholder="Örn: Salon" />
      </div>

      <div className="form-group">
        <label>Ürün Adı *</label>
        <CreatableSelect
          options={productOptions}
          value={
            productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
            (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
          }
          onChange={(option) => {
            if (!option) {
              onFieldChange('productName', '');
              onFieldChange('unitPrice', '');
              onFieldChange('baseUnitPrice', '');
            } else if (option.__isNew__) {
              onFieldChange('productName', option.value);
              onFieldChange('unitPrice', '');
              onFieldChange('baseUnitPrice', '');
            } else {
              handleProductSelect(option.value);
            }
          }}
          isDisabled={isLoading}
          isClearable
          isSearchable
          placeholder="Ürün seçin veya yazın..."
          noOptionsMessage={() => "Ürün bulunamadı"}
          formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
          styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ürün Varyantı</label>
        <input
          type="text"
          value={newOrder.productVariant || ''}
          onChange={(e) => onFieldChange('productVariant', e.target.value)}
          disabled={isLoading}
          placeholder="Renk, desen vb. giriniz..."
        />
      </div>

      <div className="form-group">
        <label>Birim Tipi</label>
        <select
          value={newOrder.birimTipi || 'adet'}
          onChange={(e) => onFieldChange('birimTipi', e.target.value)}
          disabled={isLoading}
        >
          <option value="adet">Adet</option>
          <option value="metre">Metre</option>
        </select>
      </div>

      {newOrder.birimTipi === 'metre' && (
        <div className="form-group">
          <label>Metre *</label>
          <input
            type="number"
            step="0.01"
            min="0.01"
            value={newOrder.usedM || ''}
            onChange={(e) => onFieldChange('usedM', e.target.value)}
            required
            disabled={isLoading}
            placeholder="Metre giriniz"
          />
        </div>
      )}

      <div className="form-group">
        <label>Birim Fiyat (₺) *</label>
        <input
          type="number"
          step="0.01"
          min="0.01"
          value={newOrder.unitPrice || ''}
          onChange={(e) => {
            onFieldChange('baseUnitPrice', e.target.value);
            onFieldChange('unitPrice', e.target.value);
          }}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Adet *</label>
        <input
          type="number"
          min="1"
          value={newOrder.quantity || ''}
          onChange={(e) => onFieldChange('quantity', e.target.value)}
          required
          disabled={isLoading}
          placeholder="Adet giriniz"
        />
      </div>

      {newOrder.productName && (
        <div className="form-group">
          <label>Toplam Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.totalPrice)}
            readOnly
            className="readonly-field total-price"
          />
        </div>
      )}
    </>
  );
};

export default AksesuarForm;
